import { Component, Input, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'mmoga-confirmation-dialog',
    standalone: true,
    imports: [CommonModule, NgSelectModule, ReactiveFormsModule],
    templateUrl: './confirmation-dialog.component.html',
    styleUrl: './confirmation-dialog.component.scss'
})
export class ConfirmationDialogComponent {
    private activeModal = inject(NgbActiveModal);

    @Input() title = '';
    @Input() message = '';
    @Input() btnOkText = 'OK';
    @Input() btnCancelText = 'Cancel';

    public decline() {
        this.activeModal.close(false);
    }

    public accept() {
        this.activeModal.close(true);
    }

    public dismiss() {
        this.activeModal.dismiss();
    }
}
